import * as RxToggleGroup from '@radix-ui/react-toggle-group';
import { ReactNode } from 'react';

import Text from '../base/Text';

type Item = {
  label: string;
  value: string | number;
  content: ReactNode;
};

export default function ToggleGroup({
  items,
  label,
  value,
  onValueChange,
  id,
  stretch,
  className,
}: {
  items: Item[];
  value?: string | number;
  onValueChange?: (value: string) => void;
  label?: string;
  id?: string;
  stretch?: boolean;
  className?: string;
}) {
  return (
    <RxToggleGroup.Root
      id={id}
      className={`flex gap-2 ${stretch ? 'w-full' : ''} ${className}`}
      type="single"
      aria-label={label}
      value={value?.toString()}
      onValueChange={(value) => {
        // This prevents deselecting the currently active button
        if (value !== '') {
          onValueChange?.(value);
        }
      }}
    >
      {items.map((item) => (
        <RxToggleGroup.Item
          key={item.value}
          className={`bg-gray-30 dark:bg-gray-60 dark:data-[state=off]:text-gray-60 dark:data-[state=off]:bg-gray-75 text-gray-90 data-[state=off]:bg-gray-15 data-[state=off]:text-gray-45 hover:data-[state=off]:bg-gray-30 dark:hover:data-[state=off]:bg-gray-60 flex h-10 min-w-[40px] items-center justify-center rounded-lg px-5 text-center data-[state=on]:cursor-default dark:text-white dark:hover:data-[state=off]:text-gray-50 ${
            stretch ? 'flex-1' : ''
          }`}
          value={item.value.toString()}
          aria-label={item.label}
        >
          <Text variant="studio/body/medium/sm">{item.content}</Text>
        </RxToggleGroup.Item>
      ))}
    </RxToggleGroup.Root>
  );
}
